import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getPages } from "../../state/modules/search";
import { isErrorOfTypeServer } from "../../state/modules/error";
import NoResults from "../NotFound/NoResults";
import AutoRetry from "./AutoRetry";
import ResultsList from "./ResultsList";

export class ProductList extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.isLoadingPrevious) {
      this.previousBodyHeight = document.body.scrollHeight;

      return;
    }
    if (prevProps.isLoadingPrevious && !this.props.isLoadingPrevious) {
      const heightDifference =
        document.body.scrollHeight - this.previousBodyHeight;
      window.scrollTo(0, heightDifference);
    }
  }

  render() {
    const {
      props: { pages, location, hasFacets, isErrorOfTypeServer }
    } = this;

    if (isErrorOfTypeServer) {
      return <AutoRetry />;
    }

    if (!pages.length && !hasFacets) {
      return <NoResults searchTerm={location.query.q} />;
    }

    return <ResultsList {...this.props} />;
  }
}

ProductList.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoadingPrevious: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({
      q: PropTypes.string
    })
  }),
  hasFacets: PropTypes.bool.isRequired,
  isErrorOfTypeServer: PropTypes.bool.isRequired
};

ProductList.defaultProps = {
  isLoadingPrevious: false,
  isErrorOfTypeServer: false
};

ProductList.displayName = "ProductList";

function mapStateToProps(state) {
  return {
    pages: getPages(state),
    offset: state.search.offset,
    isLoading: state.search.isLoading,
    isLoadingPrevious: state.search.isLoadingPrevious,
    showLoadMore: state.search.showLoadMore,
    showLoadPrevious: state.search.showLoadPrevious,
    tileToFocus: state.search.tileToFocus,
    isErrorOfTypeServer: isErrorOfTypeServer(state)
  };
}

export default connect(mapStateToProps)(ProductList);
